module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNmQ2MTZjYmVlOTM0OTM2MjA3OTUyZTc4NTRmMGFkYjEucG5nIjs="